<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        
        <a-row :gutter="12" style="margin:0px 0px 16px 0px;">
          <a-col class="a-large-form" >
            <a-form-item label="" style="margin-bottom:0px;width:100%">
              <a-input placeholder="请输入课程名称" v-model="queryParam.className"></a-input>
            </a-form-item>
          </a-col>
          <a-col class="a-large-form" >
            <a-form-item
            style="margin-bottom:0px;width:100%"
            label=""
            :required="false"
          >
          <a-select placeholder="选择老师">
            <a-select-option value="">所有课程</a-select-option>
            <a-select-option value="0">张老师</a-select-option>
            <a-select-option value="1">魏老师</a-select-option>
            <a-select-option value="2">万老师</a-select-option>
          </a-select>

          </a-form-item>
          </a-col>
          <a-col class="a-large-form" >
            <a-form-item
            style="margin-bottom:0px;width:100%"
            label=""
            :required="false"
          > 
            <a-select placeholder="日程状态">
              <a-select-option value="">所有状态</a-select-option>
              <a-select-option value="0">未开始</a-select-option>
              <a-select-option value="1">授课中</a-select-option>
              <a-select-option value="2">已结束</a-select-option>
            </a-select>
            <!-- <j-dict-select-tag v-model="queryParam.courseStatus" placeholder="请选择更新状态" 
                  dictCode="shelf_status"/> -->
            </a-form-item>
          </a-col>
          
          
          <a-button type="primary" @click="searchQuery" style="margin-left:5px;vertical-align: middle;">筛选</a-button>
          <!-- <a-button @click="courseCreate()" type="primary" icon="plus" style="float:right;">新增班级</a-button> -->

        </a-row>
      </a-form>
    </div>
    <div>
      <div class="class-schedule-con">
        <div class="class-schedule-title">
          <span class="class-schedule-left-arrow" @click="prevWeek()"><a-icon type="left" /></span>
          <span class="sc-date-range">
            {{startDateString}}-{{endDateString}}
          </span>
          <span class="class-schedule-right-arrow" @click="nextWeek()"><a-icon type="right" /></span>

          <!-- <span>本周</span> -->
        </div>
        <div class="class-schedule-list">
          <div class="class-schedule-header" id="classHd">
              <div class="class-schedule-header-cell" v-for="(it,index) in classScheduleHeader " :key="index">
                {{it.weekName}}({{it.weekDate}})
              </div>
          </div>
          <div class="class-schedule-body" :style="{height:windowHeight-280+'px'}" id="classId">
            <div class="class-schedule-body1">
              <div data-v-4c9da701="" class="class-schedule-body-time">
                <div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  00:00
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  00:15
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  00:30
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  00:45
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  01:00
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  01:15
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  01:30
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  01:45
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  02:00
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  02:15
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  02:30
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  02:45
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  03:00
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  03:15
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  03:30
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  03:45
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  04:00
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  04:15
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  04:30
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  04:45
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  05:00
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  05:15
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  05:30
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  05:45
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  06:00
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  06:15
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  06:30
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  06:45
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  07:00
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  07:15
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  07:30
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  07:45
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  08:00
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  08:15
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  08:30
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  08:45
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  09:00
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  09:15
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  09:30
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  09:45
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  10:00
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  10:15
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  10:30
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  10:45
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  11:00
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  11:15
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  11:30
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  11:45
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  12:00
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  12:15
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  12:30
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  12:45
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  13:00
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  13:15
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  13:30
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  13:45
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  14:00
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  14:15
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  14:30
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  14:45
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  15:00
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  15:15
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  15:30
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  15:45
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  16:00
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  16:15
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  16:30
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  16:45
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  17:00
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  17:15
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  17:30
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  17:45
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  18:00
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  18:15
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  18:30
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  18:45
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  19:00
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  19:15
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  19:30
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  19:45
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  20:00
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  20:15
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  20:30
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  20:45
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  21:00
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  21:15
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  21:30
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  21:45
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  22:00
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  22:15
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  22:30
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  22:45
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  23:00
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  23:15
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  23:30
                </div><div data-v-4c9da701="" class="class-schedule-body-time-cell">
                  23:45
                </div>
              </div>
              <div class="class-schedule-body-con">
                <div class="class-schedule-body-tr" v-for="(tdi,index1) in tdNum">
                  <div class="class-schedule-body-cell-td" v-for="(tri,index) in classScheduleHeader" @click="toCreateSchedule(index,index1)">
                    <!-- {{index}}--{{index1}}
                     -->
                     <div v-if="index==2&&index1==3&&indexNum==0">
                       <p>课程：语文</p>
                       <p>老师：魏老师</p>
                       <p>教室：二楼201教室</p>
                     </div>

                     <div v-if="index==4&&index1==4&&indexNum==0">
                       <p>课程：数学</p>
                       <p>老师：杨老师</p>
                       <p>教室：一楼102教室</p>
                     </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- table区域-end -->

    <!-- 表单区域 -->
    <!-- <courseCreate-modal ref="modalForm" @ok="modalFormOk"/> -->

  </a-card>
</template>

<script>

  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import {updateShelf} from '@/api/api'
  // import CourseCreateModal from '../../../components/myCourse/myCourseList/CourseCreateModal'

  export default {
    name: "ClassList",
    mixins: [JeecgListMixin],
    components: {
      
    },
    data () {
      return {
        description: '课程管理页面',
        sex:"0",
        indexNum :0,
        startDateString:"",
        endDateString:"",
        queryParam:{
          courseType:"",
          courseName:"",
          courseStatus:""
        },
        windowHeight:0,
        // scheduleTimeList:[
        //   "00:00",
        //   "00:15",
        //   "00:00",
        //   "00:00",
        //   "00:00",
        //   "00:00",
        //   "00:00",
        //   "00:00",
        //   "00:00",
        //   "00:00",
        //   "00:00",
        //   "00:00",
        // ],
        scheduleBodyList:[
          
        ],

        tdNum:96,
        // 表头
        classScheduleHeader: [
          {
            'weekName':'周一',
            'weekDate':""
          },
          {
            'weekName':'周二',
            'weekDate':""
          },
          {
            'weekName':'周三',
            'weekDate':""
          },
          {
            'weekName':'周四',
            'weekDate':""
          },
          {
            'weekName':'周五',
            'weekDate':""
          },
          {
            'weekName':'周六',
            'weekDate':""
          },
          {
            'weekName':'周日',
            'weekDate':""
          }
        ],
        dataSource1:[
          {
            'className':"拉丁舞A班",
            'suoshu':"拉丁舞",
            'kaiban':"2019-09-01/2020-07-01",
            'bjzt':"已开课",
            'baiMing':"100",
            'paiTime':"10"
          },
        ],
        // 请求参数
    	url: {
            list: "/course/list",
            delete: "/course/edit/delete",
            deleteBatch: "/course/elinkxCourse/deleteBatch",
            exportXlsUrl: "course/elinkxCourse/exportXls",
            importExcelUrl: "course/elinkxCourse/importExcel",
          },
        }
      },
      computed: {
        importExcelUrl: function(){
          return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
        }
      },


    methods: {

      courseCreate(){
        this.$router.push({ path:'/classManage/classCreate'});
      },

      courseDetail(id){
        this.$router.push({ path:'/classManage/classCreate?courseId='+id});
      },
      courseEdite(id){
        this.$router.push({ path:'/classManage/classCreate?courseId='+id});
      },
      toCreateSchedule(i,j){
        if(i==2&&j==3){
          this.$router.push({ path:'/classScheduleManage/ClassScheduleCreate?scheduleId=1'});
        }else if(i==4&&j==4){
          this.$router.push({ path:'/classScheduleManage/ClassScheduleCreate?scheduleId=2'});
        }
        else{
          this.$router.push({ path:'/classScheduleManage/ClassScheduleCreate'});
        }
      },
      offShelfCourse(id){
        updateShelf({id:id}).then((res)=>{
          if(res.code==0){
            console.log(res)
            this.$message.success(res.message);
            this.loadData();

          }else{
            this.$message.warning(res.message);
          }

        }).finally(() => {
          
        })
      },
      scrollFunction(){
        document.getElementById('classHd').scrollLeft = document.getElementById('classId').scrollLeft
      },
      initCalendar(){
        this.startDateString = this.getWeek(0+this.indexNum*7);
        this.endDateString = this.getWeek(7+this.indexNum*7-1);
        for(let i = 0;i<7;i++){
          this.classScheduleHeader[i].weekDate = this.getWeek(i+this.indexNum*7);
        }
      },
      getWeek(i) {
        let now = new Date();
        let firstDay=new Date(now - (now .getDay() - 1 ) * 86400000);
        firstDay.setDate(firstDay.getDate() + i);
        let mon = Number(firstDay.getMonth()) + 1;
        return now .getFullYear() + "/" + mon + "/" + firstDay.getDate();
      },
      prevWeek(){
        if(this.indexNum==0){
          return;
        }
        this.indexNum--;
        this.initCalendar();
      },
      nextWeek(){
        this.indexNum++;
        this.initCalendar();
      }
    },
    created:function(){
      this.windowHeight = window.innerHeight;
    },
    mounted:function(){
      this.initCalendar();
      setTimeout(()=>{
        this.scrollDiv = document.getElementById('classId');
      //绑定事件
        this.scrollDiv.addEventListener('scroll',this.scrollFunction,{ passive: false })
      },2000)
      // document.getElementById('classId').onscroll= function(){

      // }
      // document.getElementById('div').scrollLeft
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>

<style lang="scss" scoped >

.class-schedule-con{
  .class-schedule-title{
    padding: 20px 0px;
    text-align: center;
    .class-schedule-left-arrow{
      border: 1px solid #ebebeb;
      cursor: pointer;
      width: 21px;
      height: 21px;
      display: inline-block;
      line-height: 19px;
      font-size: 10px;
    }
    .class-schedule-right-arrow{
      border: 1px solid #ebebeb;
      cursor: pointer;
      width: 21px;
      height: 21px;
      display: inline-block;
      line-height: 19px;
      font-size: 10px;
    }
  }
  .class-schedule-list{
    padding:10px 20px;
    .class-schedule-header{
      display: -webkit-box;
      display: -webkit-flex;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      height: 45px;
      padding-left: 50px;
      line-height: 45px;
      border-bottom: 1px solid #eee;
      overflow: hidden;
      .class-schedule-header-cell{
        -webkit-flex-shrink: 0;
        -ms-flex-negative: 0;
        flex-shrink: 0;
        width: 200px;
        text-align: center;
      }
    }
    .class-schedule-body{
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      height: calc(100% - 205px);
      padding: 10px 0;
      // overflow-x: hidden;
      overflow-y: auto;
      .class-schedule-body1{
        display: -webkit-box;
      display: -webkit-flex;
      display: -ms-flexbox;
      display: flex;
      }
      .class-schedule-body-time{
        display: -webkit-box;
      display: -webkit-flex;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-flex: 0;
      -webkit-flex: 0 0 auto;
      -ms-flex: 0 0 auto;
      flex: 0 0 auto;
      -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
      -webkit-flex-direction: column;
      -ms-flex-direction: column;
      flex-direction: column;
      margin-right: 20px;
        .class-schedule-body-time-cell{
          -webkit-flex-shrink: 0;
          -ms-flex-negative: 0;
          flex-shrink: 0;
          height: 55px;
          color: #888;
          font-size: 12px;
          line-height: 17px;
          cursor: pointer;

         
        }
      }
      .class-schedule-body-con{
        .class-schedule-body-tr{
          width: 1400px;
          .class-schedule-body-cell-td{
            position: relative;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            height: 55px;
            border-top: 1px dashed #eee;
            border-right: 1px dashed #eee;
            float: left;
            width: 200px;
            cursor: pointer;
            padding:5px 0px;
            &:hover{
              background-color: #f9f9f9;
            }
            p{
              margin: 0px;
              font-size:12px;
              padding:0px 5px;
              line-height: 1.2;
            }
          }
        }
      }
    }
  }
}
  .course-img{
    float: left;
  }
  .course-right{
    padding-left:10px;
    text-align:left;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-left:90px;
    .course-name{
      font-size:14px;
      color: #0091FF;
      padding: 10px 0px;
    }
    .course-money{
      font-size:14px;
      color: #FA6400;
      
    }
  }
</style>